import styled from "styled-components";

import soapImg from "../../../../assets/Mayo/soap.png"

const SOAP_INSTRUCTIONS_LIST = [
  {
    timeText: "The night before:",
    text: "Please use the first packet."
  },
  {
    timeText: "On the morning of your procedure:",
    text: "Please use the second packet."
  },
  {
    timeText: "Follow the instructions provided:",
    text: "Wash the area as directed. Keep it on your body for 3-5 minutes before washing it off."
  }
]

export default function SoapInstructions({style}) {
  return (
    <Container style={style}>
      <Image
        src={soapImg}
        height={90}
        width={80}
        style={{marginBottom: 10}}
      />
      <Title>You Received Packets Of Antiseptic Soap:</Title>
      <StepList>
        <Step>
          <Dot />
          <StepText>
            The night before:<br/>
            Please use the first packet.
          </StepText>
        </Step>
        <Step>
          <Dot />
          <StepText>
            On the morning of your procedure: <br/>
            Please use the second packet.
          </StepText>
        </Step>
        <Step>
          <Dot />
          <StepText>
            Follow the instructions provided:<br/> 
            Wash the area as directed. Keep it on your body for 3-5 minutes before washing it off.
          </StepText>
        </Step>
      </StepList>
    </Container>
  );
}
const Container = styled.div`
  color: #222;
  margin-left: 26px;
  margin-top: 19px;
`;

const Image = styled.img``

const Title = styled.h3`
  font-size: 22px;
  font-weight: bold;
  margin: 0;
  margin-right: 42px;
  margin-bottom: 19px;
`;

const StepList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  margin-right: 38px;
  position: relative;
`;

const Step = styled.li`
  display: flex;
  align-items: flex-start;
  gap: 19px;
  padding-bottom: 26px;
  position: relative;
  &::after {
    content: "";
    position: absolute;
    top: 10px;
    left: 4px;
    transform: translateX(-50%);
    width: 2px;
    transform: scaleX(0.5);
    height: calc(100%);
    background: repeating-linear-gradient(
      to bottom,
      #7A9DFD,
      #7A9DFD 2px,
      transparent 2px,
      transparent 4px
    );
  }
  /* Remove line for last step */
  &:last-child::after {
    display: none;
  }
`;

const Dot = styled.div`
  width: 11px;
  height: 11px;
  border-radius: 50%;
  background: #83A4FC;
  flex-shrink: 0;
`;

const StepText = styled.p`
  margin: 0;
  font-size: 19px;
  line-height: 1.4;
`;
